// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";

import Page from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import loadCustomerPartNumbers from "@steiner/App/Handlers/CustomerPartNumber/LoadCustomerPartNumbers";
import updateSearchField from "@steiner/App/Handlers/CustomerPartNumber/UpdateSearchField";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import Modals from "@steiner/Overrides/Components/Modals";
import qs from "qs";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        customerPartNumber: state.xCustomerPartNumbers.customerPartNumber,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    loadCustomerPartNumbers,
    updateSearchField,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const CustomerPartNumberPage = ({
    id,
    customerPartNumber,
    loadCustomerPartNumbers,
    location,
    updateSearchField,
}: Props) => {
    let firstLoad = false;
    const history = useHistory();

    useEffect(() => {
        firstLoad = true;
        const { customerPartNumber = "" } = parseQueryString<{ customerPartNumber?: string }>(location.search);

        loadCustomerPartNumbers({
            customerPartNumber,
            pageSize: 16,
        });
        updateSearchField({
            customerPartNumber,
        });
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            const queryString = customerPartNumber ? qs.stringify({ customerPartNumber }) : "";
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [customerPartNumber]);

    return (
        <>
            <Page data-test-selector="CustomerPartNumber">
                <Zone contentId={id} zoneName="Content"></Zone>
            </Page>
            <Modals />
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CustomerPartNumberPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "CustomerPartNumberPage" instead of this constant.
 */
export const EditCustomerPartNumberPageContext = "CustomerPartNumberPage";
